/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ term: NonNullable<unknown> }} Event_Tags_Remove_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Remove {term}" |
*
* @param {Event_Tags_Remove_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_tags_remove_aria_label = /** @type {((inputs: Event_Tags_Remove_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Tags_Remove_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Retirer ${i?.term}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Entferne ${i?.term}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimuovi ${i?.term}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Удалить ${i?.term}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Eliminar ${i?.term}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`移除${i?.term}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.term} を削除`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.term} को हटाएँ`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Remover ${i?.term}`)
	return /** @type {LocalizedString} */ (`Remove ${i?.term}`)
});